module.exports = __webpack_public_path__ + "93d6832dc265e366610190e5d1af6b42.svg";